import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import ListItem from '../../shared/ListItem';

import Event from './Event';
import {withRouter} from 'react-router-dom';

import TrayContainerWithHeader from '../../shared/TrayContainerWithHeader';
import {getEvents, getEvent} from '../../../sources/Events';

@inject('mapStore')
@withRouter
@observer
class WhatsOn extends Component {
  componentDidMount() {
    if (this.props.match.params.id) {
        getEvent({slug: this.props.match.params.id}, this.props.mapStore).then((response) => {
        this.props.mapStore.currentItem = response.data;
        this.props.mapStore.trayContainerClass = 'is-flexible';
      });
    // } else {
    //   getEvents().then((response) => {
    //     this.props.mapStore.events.replace(response.data);
    //   });
    }
  }

  getChildComponent() {
    let child;

    if (this.props.match.params.id && this.props.mapStore.currentItem) {
      let event = <Event {...this.props.mapStore.currentItem} />

      child =
        <TrayContainerWithHeader title="Showing" trayClass="event-detail" currentItem={this.props.mapStore.currentItem} mapStore={this.props.mapStore} params={{path: '/find/whats-on', ...this.props.match.params}}>
          {event}
        </TrayContainerWithHeader>
    } else if (this.props.match.params.id && !this.props.mapStore.currentItem) {
      // loading state
      return <React.Fragment></React.Fragment>
    } else {
      let results = (<div className="results">
        <div className="scroll-pane">

          {this.props.mapStore.events.map((data, i) => {
            return <ListItem key={`${this.props.match.url}-list-id-${i}`} path={`/find/whats-on/${data.slug}`} name={data.title} data={{'tracking-mapwhatson': data.title}} subTitle={data.date} itemType="event"/>
          })}

          <div className="note">
            If an event is not listed, please speak to a member of staff to point you in the right direction, or…
          </div>

          <div className="link">
            <a href="https://www.vam.ac.uk/whatson" data-tracking-mapwhatson="V&A What's on">View all our events</a>
          </div>

        </div>
      </div>);

      child =
        <TrayContainerWithHeader title="What's on today" trayClass="whats-on-today" params={this.props.match.params}>
          {results}
        </TrayContainerWithHeader>
    }

    return (
      <div>
        {child}
      </div>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.getChildComponent()}
      </React.Fragment>
    )
  }
}

export default WhatsOn;
